import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Router from './router/Router';

import './assets/fonts/Butler/Butler_Black.otf';
import './assets/fonts/Butler/Butler_Bold.otf';
import './assets/fonts/Butler/Butler_ExtraBold.otf';
import './assets/fonts/Butler/Butler_Light.otf';
import './assets/fonts/Butler/Butler_Medium.otf';
import './assets/fonts/Butler/Butler_Regular.otf';
import './assets/fonts/Butler/Butler_SemiBold.otf';
import './assets/fonts/Avenir/AvenirLTStd-Black.otf';
import './assets/fonts/Avenir/AvenirLTStd-Book.otf';
import './assets/fonts/Avenir/AvenirLTStd-Heavy.otf';
import './assets/fonts/Avenir/AvenirLTStd-Light.otf';
import './assets/fonts/Avenir/AvenirLTStd-Medium.otf';
import './assets/fonts/Avenir/Avenir-Roman.otf';
import './assets/fonts/Avenir/AvenirLTStd-Roman.otf';
import './assets/fonts/Almarai/Almarai-Bold.ttf';
import './assets/fonts/Almarai/Almarai-ExtraBold.ttf';
import './assets/fonts/Almarai/Almarai-Light.ttf';
import './assets/fonts/Almarai/Almarai-Regular.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-Black.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-Bold.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-ExtraBold.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-Medium.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-Regular.ttf';
import './assets/fonts/PlayfairDisplay/PlayfairDisplay-SemiBold.ttf';
import './assets/fonts/SaudiRiyal/Saudi-Riyal.ttf';

import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'sonner';

// Keep the trailing slash before the hash route: /corporate-oao-web#/x -> /corporate-oao-web/#/x
if (process.env.PUBLIC_URL && window.location.pathname === process.env.PUBLIC_URL) {
    window.history.replaceState(null, '', `${process.env.PUBLIC_URL}/${window.location.search}${window.location.hash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <Toaster
                    toastOptions={{
                        style: {
                            backgroundColor: '#fff',
                            borderColor: '#ccc',
                            color: 'black',
                        },
                        descriptionClassName: 'toast-description',
                    }}
                />
                <Router />
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
